import { groq } from "next-sanity"

import { AppSettings } from "@/settings"

import { filterOutArticlesNotAvailableInBranchOffice } from "../../product/utils/filters"
import { checkPermissions } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { groqArticleProjection } from "../../shared/sanity/article.projection"
import { getEnrichedArticles } from "../../shared/utils/getArticleInformation"

export const queryBundle = {
  async bundle(parent, args, context, info) {
    const { lang = AppSettings.defaultLocale(), cdn = true, id, loggedInBranch, customerId } = args

    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.ARTICLES,
      operation: Operations.READ,
    })

    if (!id) return null

    const config = AppSettings.sanityConfigByLang(lang)
    const client = context.sanityClient
    client.config({ ...config, useCdn: cdn })

    const draftsFilter = `&& !(_id in path("drafts.**"))`

    let bundle
    bundle = await client.fetch(
      groq`*[_type=="bundle" && _id==$id ${draftsFilter}][0] {  
        "id": _id,
        "type": _type,
        title,
        altTitle,
        image,
        descriptionBlocks,
        attachments[]{
            label,
            file{
              asset->{url, originalFilename}
          },
        },
        variants[]->{
              ...,
            ${groqArticleProjection()}
          }
        }`,
      { id },
    )

    if (bundle.variants) {
      if (loggedInBranch) {
        bundle.variants = filterOutArticlesNotAvailableInBranchOffice(bundle.variants, loggedInBranch)
      }

      bundle.variants = await getEnrichedArticles({
        context,
        articles: bundle.variants,
        branchId: loggedInBranch,
        customerNumber: null,
        customerId: customerId,
      })
    }

    return bundle
  },
}
